// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TAay","content":"styles_content__u2nxl"};